import { LOCAL_LANGUAGE_KEY } from 'constants/localStorageKey';
import { ERoleName, EUserLanguage } from '@miotech/esghub-web-lib-common';
import { useRequest } from 'ahooks';
import { Options } from 'ahooks/lib/useRequest/src/types';
import { getWhoAmI } from 'services/user/user.service';
import { IWhoAmIApiData } from 'services/user/types';
import { setInterceptorsRequestHeaders } from '../services/base';
import useRedux from './useRedux';

export const useUserWhoAmIRequest = (options?: Options<IWhoAmIApiData, []>) => {
  const { dispatch } = useRedux(s => ({
    userInfo: s.mainApp.userInfo,
  }));
  const request = useRequest(
    () =>
      getWhoAmI().then(result => {
        dispatch.mainApp.updateWhoAmi({
          userId: result.userId,
          basicInfo: { ...result, displayName: result.username },
          preference: {
            language: result.language,
          },
        });
        setInterceptorsRequestHeaders(result.userId);
        dispatch.mainApp.updateInternalWhoAmi({
          ...result.companyBasicInfo,
          subscriptionFeatures: result.companyBasicInfo?.subscriptionFeatures || [],
          roleInfo: [{ roleId: result.companyBasicInfo?.roleId }],
        });
        const language = Object.values(EUserLanguage).includes(result?.language)
          ? result?.language
          : EUserLanguage.ZH_CN;
        if (language) {
          localStorage.setItem(LOCAL_LANGUAGE_KEY, language);
          dispatch.mainApp.updateLanguageCache(language);
        }
        return result;
      }),
    {
      ...(options || {}),
    },
  );
  return request;
};

export const useUserRole = () => {
  const { selector } = useRedux(s => ({
    userInfo: s.mainApp.userInfo,
    companyInfo: s.mainApp.userInfo.internalWhoAmi,
  }));
  const roles = selector.userInfo.internalWhoAmi.roleInfo || [];
  const isAdmin = roles.some(ele => ele.roleId === ERoleName.Admin);
  return {
    isAdmin,
    showLockedModule: isAdmin && !selector.companyInfo?.isHideInactiveFeature,
  };
};
